import * as ACTIONTYPE from '../constants/actiontypes'

export const PLACEHOLDER_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const initalBook = {
  audio_info: {},
  audio_full: {},
  cover_h: {},
  cover_v: {},
  text: {},
  jpg: {},
  encriptedImages: {},
  small: {},
  sub: {},
  video_hls: {},
  bookInfo: {},
  loading: false,
  hasText: true,
  framesTime: [],
};

export default function (state = initalBook, action) {
  switch (action.type) {
    case ACTIONTYPE.ADD_BOOK:
      return {
        ...state,
        ...action.bookData
      };
    case ACTIONTYPE.ADD_BOOK_FRAMES:
      return { ...state, framesTime: action.framesTime };
    case ACTIONTYPE.FETCH_BOOK_START:
      return { ...state, loading: true };
    case ACTIONTYPE.FETCH_BOOK_FINISH:
      return { ...state, loading: false };
    case ACTIONTYPE.ENCRYPTED_IMAGE_LOADED:
      return {
        ...state,
        encriptedImages: {
          ...state.encriptedImages,
          [action.imageIndex]: action.encodedImg
        }
      };
    case ACTIONTYPE.ENCRYPTED_REQUEST_SENDED:
      return {
        ...state,
        encriptedImages: {
          ...state.encriptedImages,
          [action.imageIndex]: PLACEHOLDER_IMAGE
        }
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/BookReducer.js